var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#F3F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1381 9.98637C21.7155 10.5638 21.725 11.497 21.1594 12.086L15.7425 17.7271C15.4672 18.0137 15.0894 18.1795 14.692 18.1878L12.4167 18.2355L12.4647 15.945C12.4729 15.5566 12.6314 15.1866 12.9068 14.9127L18.4438 9.40735C19.0301 8.82442 19.9775 8.82578 20.5621 9.41038L21.1381 9.98637Z",
    fill: "#3699FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5999 8.3333C15.9681 8.3333 16.2666 8.63177 16.2666 8.99996C16.2666 9.36815 15.9681 9.66663 15.5999 9.66663H10.9999C10.2635 9.66663 9.66659 10.2636 9.66659 11V19C9.66659 19.7363 10.2635 20.3333 10.9999 20.3333H18.9999C19.7363 20.3333 20.3333 19.7363 20.3333 19V15.6666C20.3333 15.2984 20.6317 15 20.9999 15C21.3681 15 21.6666 15.2984 21.6666 15.6666V19C21.6666 20.4727 20.4727 21.6666 18.9999 21.6666H10.9999C9.52716 21.6666 8.33325 20.4727 8.33325 19V11C8.33325 9.5272 9.52716 8.3333 10.9999 8.3333H15.5999Z",
    fill: "#3699FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonEdit);
export default __webpack_public_path__ + "static/media/ButtonEdit.44c1605dd794eefd83861d7dd8320f79.svg";
export { ForwardRef as ReactComponent };